import { Typography } from "@mui/material";
import React from "react";

export default function Header() {
  return (
    <div className="relative pt-16 pb-32 flex content-center items-center justify-center h-screen">
      <div className="bg-landing-background bg-cover bg-center absolute top-0 w-full h-full" />
      <div className="container max-w-8xl relative mx-auto">
        <div className="items-center flex flex-wrap">
          <div className="w-full lg:w-6/12 px-4 ml-auto mr-auto text-center">
            {/* <H2 color="white">LabAsService</H2> */}
            <Typography variant="h2" color="white" className="mb-4">
                            LabAsService
            </Typography>
            <div className="text-gray-200">
              <Typography variant="body1" sx={{ color: 'white' }}>
                pre-configured lab servers on the cloud which can be accessed
                from any machine with an Internet connection
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}